const syncAriaHiddenFocus = (slider) => {
  const focusableSelector =
    'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const update = () => {
    slider.slides.forEach((slide) => {
      const isHidden = slide.getAttribute("aria-hidden") === "true";
      const focusables = slide.querySelectorAll(focusableSelector);

      if (isHidden) {
        slide.setAttribute("inert", "");
        focusables.forEach((el) => {
          if (el.hasAttribute("data-prev-tabindex")) return;
          const prev = el.getAttribute("tabindex");
          el.setAttribute("data-prev-tabindex", prev === null ? "" : prev);
          el.setAttribute("tabindex", "-1");
        });
      } else {
        slide.removeAttribute("inert");
        focusables.forEach((el) => {
          if (!el.hasAttribute("data-prev-tabindex")) return;
          const prev = el.getAttribute("data-prev-tabindex");
          if (prev === "") {
            el.removeAttribute("tabindex");
          } else {
            el.setAttribute("tabindex", prev);
          }
          el.removeAttribute("data-prev-tabindex");
        });
      }
    });
  };

  slider.on("created", update);
  slider.on("detailsChanged", update);
  slider.on("slideChanged", update);
  slider.on("updated", update);
};

// Fader single-image slider with left text panel and autoplay/progress bars
if (window.Drupal && window.once) {
  (function (Drupal, once) {
    Drupal.behaviors.faderSliderInit = {
      attach(context) {
        try {
          const regions = once(
            "fader-slider-init",
            "[data-fader-slider], .keen-slider-region[data-fader-slider]",
            context
          );
          regions.forEach((wrapper) => {
            const container = wrapper.querySelector(".js-fader-keen");
            if (!(container && window.keen && window.keen.KeenSlider)) return;

            const titleEl = wrapper.querySelector(".js-ann-title");
            const previewEl = wrapper.querySelector(".js-ann-preview");
            const primaryBtn = wrapper.querySelector(".js-ann-primary");
            const leftPanel = wrapper.querySelector(".next-ann-left");
            const barsWrap = wrapper.querySelector(".js-ann-bars");
            const toggleBtn = wrapper.querySelector(".js-ann-toggle");
            let currentLeftIndex = 0; // which slide's text is currently shown

            // -------- Config via data-attributes (wrapper has priority) --------
            const ds = Object.assign(
              {},
              container?.dataset || {},
              wrapper?.dataset || {}
            );
            const toBool = (v, d = false) =>
              typeof v === "string" ? v.toLowerCase() === "true" : d;
            const toNum = (v, d) =>
              v !== undefined && v !== null && v !== "" && !isNaN(Number(v))
                ? Number(v)
                : d;

            const loop = toBool(ds.loop, true);
            const renderMode = "custom";
            const rubberband = toBool(ds.rubberband, false);
            const spacing = toNum(ds.spacing, 0);
            const perView = toNum(ds.perView, 1);
            const perViewSm = toNum(ds.perViewSm, perView);
            const perViewMd = toNum(ds.perViewMd, perView);
            const perViewLg = toNum(ds.perViewLg, perView);
            const perViewXl = toNum(ds.perViewXl, perView);
            const autoplay = toBool(ds.autoplay, true);
            const autoplayDuration = toNum(ds.autoplayDuration, 5000);
            const pauseOnHover = toBool(ds.autoplayPauseOnHover, true);
            const pauseOnFocus = toBool(ds.autoplayPauseOnFocus, false);
            const slides = Array.from(
              container.querySelectorAll(".keen-slider__slide")
            );
            const totalSlides = slides.length;

            const setLeftPanelFromHost = (host) => {
              if (!host) return;
              const title = host.getAttribute("data-ann-title") || "";
              const preview = host.getAttribute("data-ann-preview") || "";
              const url = host.getAttribute("data-ann-url") || "#";
              if (titleEl) titleEl.textContent = title;
              if (previewEl) previewEl.innerHTML = `<p>${preview}</p>`;
              if (primaryBtn) primaryBtn.setAttribute("href", url);
            };

            if (totalSlides <= 1) {
              const host = container.querySelector(".ann-slide");
              setLeftPanelFromHost(host);

              if (slides[0]) {
                slides[0].style.opacity = "1";
                slides[0].removeAttribute("aria-hidden");
                slides[0].removeAttribute("inert");
              }

              const controlsWrap = wrapper.querySelector(".js-ann-controls");
              const controlsToHide = [
                controlsWrap,
                toggleBtn,
                barsWrap,
                barsWrap?.parentElement,
              ].filter(Boolean);
              controlsToHide.forEach((el) => {
                el.style.display = "none";
                el.setAttribute("hidden", "hidden");
              });
              if (barsWrap) barsWrap.innerHTML = "";
              if (leftPanel) {
                leftPanel.style.transition = "none";
                leftPanel.style.opacity = "1";
              }

              return;
            }

            const plugins = [
              window.keen.Accessibility,
              syncAriaHiddenFocus,
              (slider) => {
                // ----- Custom autoplay with pause/resume timecode -----
                let paused = !autoplay; // start paused if autoplay disabled via data-attr
                let elapsedMs = 0; // elapsed time within current slide
                const durationMs = autoplayDuration;
                let transitionListener = null;
                let activeTransitionFill = null; // track element that owns the listener
                const leftFadeMs = 300;
                let lastSlideChangeRel = null;
                let lastSlideChangeTs = 0; // ms timestamp

                const getActiveIndex = () => slider.track?.details?.rel || 0;
                const getBars = () =>
                  barsWrap
                    ? barsWrap.querySelectorAll(".progress-bar-ann")
                    : [];
                const getActiveFill = () => {
                  const idx = getActiveIndex();
                  const bars = getBars();
                  const bar = bars[idx];
                  return bar ? bar.querySelector(".progress-bar__thumb") : null;
                };

                function setToggleState() {
                  const span = toggleBtn?.querySelector("span");
                  const img = toggleBtn?.querySelector("img");
                  if (span) span.textContent = paused ? Drupal.t("Play") : Drupal.t("Pause");
                  if (toggleBtn)
                    toggleBtn.setAttribute(
                      "aria-label",
                      paused ? Drupal.t("Autoplay") : Drupal.t("Pause autoplay")
                    );
                  if (img) {
                    img.src = paused
                      ? "/themes/custom/b5nova/resources/icons/play-button.svg"
                      : "/themes/custom/b5nova/resources/icons/pause-button.svg";
                  }
                }

                function computePercentFromElapsed() {
                  const pct = Math.max(
                    0,
                    Math.min(1, durationMs ? elapsedMs / durationMs : 0)
                  );
                  return pct * 100;
                }

                function updateActiveBarWidthForPause() {
                  const fill = getActiveFill();
                  if (!fill) return;
                  const pct = computePercentFromElapsed();
                  fill.style.transition = "none";
                  fill.style.width = pct + "%";
                }

                function clearTransitionListener(fill) {
                  if (!transitionListener) return;
                  // Remove from explicitly provided element
                  if (fill) {
                    fill.removeEventListener(
                      "transitionend",
                      transitionListener
                    );
                  }
                  // Also remove from the last element that had the listener, if different
                  if (activeTransitionFill) {
                    activeTransitionFill.removeEventListener(
                      "transitionend",
                      transitionListener
                    );
                  }
                  transitionListener = null;
                  activeTransitionFill = null;
                }

                function startProgress() {
                  const fill = getActiveFill();
                  if (!fill) return;
                  const bars = getBars();
                  // Reset all non-active bars
                  const rel = getActiveIndex();
                  bars.forEach((bar, idx) => {
                    const f = bar.querySelector(".progress-bar__thumb");
                    if (!f) return;
                    if (idx !== rel) {
                      // smoothly collapse previous fills
                      // Ensure no stray listeners remain on any non-active fill
                      if (transitionListener) {
                        f.removeEventListener(
                          "transitionend",
                          transitionListener
                        );
                      }
                      f.style.transition = "width 180ms ease";
                      f.style.width = "0%";
                    }
                  });

                  // Set current width based on elapsed
                  const pct = computePercentFromElapsed();
                  // Clear any previous listener bound to older fill before starting anew
                  clearTransitionListener(fill);
                  fill.style.transition = "none";
                  fill.style.width = pct + "%";
                  // force reflow
                  void fill.offsetWidth;
                  if (paused) return; // do not animate while paused

                  const remaining = Math.max(0, durationMs - elapsedMs);
                  transitionListener = (e) => {
                    if (e.propertyName !== "width") return;
                    clearTransitionListener(fill);
                    elapsedMs = 0;
                    slider.next();
                  };
                  fill.addEventListener("transitionend", transitionListener);
                  activeTransitionFill = fill;
                  fill.style.transition = `width ${remaining}ms linear`;
                  requestAnimationFrame(() => {
                    fill.style.width = "100%";
                  });
                }

                function pauseProgress() {
                  paused = true;
                  const fill = getActiveFill();
                  if (!fill) {
                    setToggleState();
                    return;
                  }
                  // Calculate current percent based on computed width
                  const parent = fill.parentElement;
                  if (parent && parent.clientWidth > 0) {
                    const currentPx = parseFloat(
                      window.getComputedStyle(fill).width || "0"
                    );
                    const pct = Math.max(
                      0,
                      Math.min(1, currentPx / parent.clientWidth)
                    );
                    elapsedMs = pct * durationMs;
                  }
                  // Freeze the bar
                  clearTransitionListener(fill);
                  fill.style.transition = "none";
                  fill.style.width = computePercentFromElapsed() + "%";
                  setToggleState();
                }

                function resumeProgress() {
                  paused = false;
                  setToggleState();
                  startProgress();
                }
                // Build bars based on slide count
                slider.on("created", () => {
                  const total = slider.slides.length;
                  if (barsWrap) {
                    barsWrap.innerHTML = "";
                    for (let i = 0; i < total; i++) {
                      const bar = document.createElement("div");
                      bar.className = "progress-bar-ann";
                      bar.setAttribute("role", "button");
                      bar.setAttribute(
                        "aria-label",
                        `Slide ${i + 1} of ${total}`
                      );
                      // Make each bar take equal width in the flex row
                      bar.style.flex = "1 1 0";
                      const fill = document.createElement("div");
                      fill.className = "progress-bar__thumb";
                      bar.appendChild(fill);
                      barsWrap.appendChild(bar);
                    }

                    // Map each bar to its slide (click/keyboard)
                    const bars = barsWrap.querySelectorAll(".progress-bar-ann");
                    bars.forEach((bar, idx) => {
                      bar.addEventListener("click", () => {
                        elapsedMs = 0;
                        slider.moveToIdx(idx);
                      });
                      // Basic keyboard support even if visually hidden from AT
                      bar.setAttribute("tabindex", "0");
                      bar.addEventListener("keydown", (e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          elapsedMs = 0;
                          slider.moveToIdx(idx);
                        }
                      });
                    });
                  }
                  updateLeftPanel(slider);
                  updateBars(slider);
                  computeAndApplyMaxLeftHeight(slider);
                  // Start progress immediately on first render
                  if (!paused) {
                    elapsedMs = 0;
                    startProgress();
                  } else {
                    updateActiveBarWidthForPause();
                  }
                  if (leftPanel) {
                    leftPanel.style.transition = "opacity 0ms";
                    leftPanel.style.opacity = "1";
                  }
                  // set initial left panel index
                  currentLeftIndex = slider.track?.details?.rel || 0;
                });

                // Keep left panel opacity in sync with slide fade and swap text mid-transition
                slider.on("detailsChanged", (s) => {
                  if (!leftPanel) return;
                  const details = s.track && s.track.details;
                  if (!details || !Array.isArray(details.slides)) return;
                  let maxPortion = 0;
                  let maxIdx = details.rel || 0;
                  details.slides.forEach((sd, idx) => {
                    if (sd.portion > maxPortion) {
                      maxPortion = sd.portion;
                      maxIdx = idx;
                    }
                  });
                  // Match slide fade easing used for slides
                  const lowerDeadZone = 0.15;
                  let t = 0;
                  if (maxPortion > lowerDeadZone) {
                    t = (maxPortion - lowerDeadZone) / (1 - lowerDeadZone);
                  }
                  const easedOpacity = t * t * (3 - 2 * t);
                  leftPanel.style.transition = "none";
                  leftPanel.style.opacity = String(
                    Math.max(0, Math.min(1, easedOpacity))
                  );
                  // Swap text when incoming slide is dominant to avoid jump
                  if (maxIdx !== currentLeftIndex && maxPortion >= 0.5) {
                    const slide = slider.slides[maxIdx];
                    if (slide) {
                      const host = slide.querySelector(".ann-slide");
                      if (host) {
                        const title = host.getAttribute("data-ann-title") || "";
                        const preview =
                          host.getAttribute("data-ann-preview") || "";
                        const url = host.getAttribute("data-ann-url") || "#";
                        if (titleEl) titleEl.textContent = title;
                        if (previewEl)
                          previewEl.innerHTML = `<p>${preview}</p>`;
                        if (primaryBtn) primaryBtn.setAttribute("href", url);
                        currentLeftIndex = maxIdx;
                      }
                    }
                  }
                });

                // Start progress only when slide animation fully ended
                slider.on("animationEnded", () => {
                  // computeAndApplyMaxLeftHeight(slider);
                  if (paused) {
                    updateActiveBarWidthForPause();
                  }
                });
                slider.on("slideChanged", () => {
                  const rel = slider.track?.details?.rel || 0;
                  const now = Date.now();
                  // Guard against duplicate slideChanged for the same rel (loop snap)
                  if (
                    lastSlideChangeRel === rel &&
                    now - lastSlideChangeTs < 1800
                  ) {
                    return;
                  }
                  lastSlideChangeRel = rel;
                  lastSlideChangeTs = now;
                  updateBars(slider);
                  // reset time and start progress immediately for the new slide
                  elapsedMs = 0;
                  if (!paused) {
                    startProgress();
                  } else {
                    updateActiveBarWidthForPause();
                  }
                });

                // Keep bars in sync when autoplay pauses/resumes
                // We manage pause/play ourselves via toggle button

                function updateBars(slider) {
                  const rel = slider.track?.details?.rel || 0;
                  const bars = barsWrap
                    ? barsWrap.querySelectorAll(".progress-bar-ann")
                    : [];
                  bars.forEach((bar, idx) => {
                    const fill = bar.querySelector(".progress-bar__thumb");
                    const isActive = idx === rel;
                    bar.classList.toggle("is-active", isActive);
                    bar.setAttribute("aria-current", isActive ? "true" : "false");
                    // Active bar appears larger than others
                    bar.style.transition = "flex 2s ease-in-out";
                    bar.style.flex = isActive ? "3.5 1 0" : "1 1 0";
                    if (!fill) return;

                    if (!isActive) {
                      // Non-active bars are reset
                      fill.style.transition = "width 180ms ease";
                      fill.style.width = "0%";
                    }
                  });
                }

                function updateLeftPanel(slider) {
                  const rel = slider.track?.details?.rel || 0;
                  const slide = slider.slides[rel];
                  if (!slide) return;
                  const host = slide.querySelector(".ann-slide");
                  if (!host) return;
                  const title = host.getAttribute("data-ann-title") || "";
                  const preview = host.getAttribute("data-ann-preview") || "";
                  const url = host.getAttribute("data-ann-url") || "#";
                  if (titleEl) titleEl.textContent = title;
                  if (previewEl) previewEl.innerHTML = `<p>${preview}</p>`;
                  if (primaryBtn) primaryBtn.setAttribute("href", url);
                }

                function fadeOutLeftPanel() {
                  if (!leftPanel) return;
                  leftPanel.style.transition = `opacity ${leftFadeMs}ms ease`;
                  leftPanel.style.opacity = "0";
                }

                function fadeInLeftPanel() {
                  if (!leftPanel) return;
                  leftPanel.style.transition = `opacity ${leftFadeMs}ms ease`;
                  void leftPanel.offsetWidth;
                  leftPanel.style.opacity = "1";
                }

                function computeAndApplyMaxLeftHeight(slider) {
                  if (!leftPanel) return;
                  const parent = leftPanel.parentElement || wrapper;
                  const clone = leftPanel.cloneNode(true);
                  clone.style.position = "absolute";
                  clone.style.visibility = "hidden";
                  clone.style.pointerEvents = "none";
                  clone.style.left = "-9999px";
                  clone.style.top = "0";
                  clone.style.height = "auto";
                  clone.style.minHeight = "0";
                  const refWidth =
                    leftPanel.clientWidth || leftPanel.offsetWidth || 0;
                  if (refWidth) clone.style.width = `${refWidth}px`;
                  parent.appendChild(clone);

                  let maxH = 0;
                  slider.slides.forEach((slide) => {
                    const host = slide.querySelector(".ann-slide");
                    if (!host) return;
                    const t = host.getAttribute("data-ann-title") || "";
                    const p = host.getAttribute("data-ann-preview") || "";
                    const u = host.getAttribute("data-ann-url") || "#";
                    const cloneTitle = clone.querySelector(".js-ann-title");
                    const clonePreview = clone.querySelector(".js-ann-preview");
                    const clonePrimary = clone.querySelector(".js-ann-primary");
                    if (cloneTitle) cloneTitle.textContent = t;
                    if (clonePreview) clonePreview.innerHTML = `<p>${p}</p>`;
                    if (clonePrimary) clonePrimary.setAttribute("href", u);
                    const h = clone.scrollHeight;
                    if (h > maxH) maxH = h;
                  });

                  parent.removeChild(clone);
                  if (maxH > 0) leftPanel.style.minHeight = `${maxH}px`;
                }

                if (toggleBtn) {
                  toggleBtn.addEventListener("click", () => {
                    if (paused) {
                      resumeProgress();
                    } else {
                      pauseProgress();
                    }
                  });
                  setToggleState();
                }

                // Recompute on resize (debounced) to maintain stable height across breakpoints
                let resizeTimer = null;
                window.addEventListener(
                  "resize",
                  () => {
                    if (resizeTimer) window.clearTimeout(resizeTimer);
                    resizeTimer = window.setTimeout(() => {
                      computeAndApplyMaxLeftHeight(slider);
                    }, 150);
                  },
                  { passive: true }
                );
              },
            ];

            new window.keen.KeenSlider(
              container,
              {
                loop: loop,
                renderMode: renderMode,
                defaultAnimation: {
                  duration: 1500,
                },
                detailsChanged: (s) => {
                  // Hold opacity at 0 a bit longer and ease the fade-in/out
                  const mapPortionToOpacity = (p) => {
                    const lowerDeadZone = 0.15; // keep 0 slightly longer
                    if (p <= lowerDeadZone) return 0;
                    const t = (p - lowerDeadZone) / (1 - lowerDeadZone);
                    // smoothstep easing for gentle ramp
                    return t * t * (3 - 2 * t);
                  };
                  s.slides.forEach((element, idx) => {
                    const portion = s.track.details.slides[idx].portion;
                    element.style.opacity = mapPortionToOpacity(portion);
                  });
                },
                rubberband: rubberband,
                drag: false, // disable swipe/drag
                slides: { perView: 1, spacing: 0 },
                breakpoints: {
                  [window.keen.minBreakpoint("sm")]: {
                    slides: { perView: 1, spacing: 0 },
                  },
                  [window.keen.minBreakpoint("md")]: {
                    slides: { perView: 1, spacing: 0 },
                  },
                  [window.keen.minBreakpoint("lg")]: {
                    slides: { perView: 1, spacing: 0 },
                  },
                  [window.keen.minBreakpoint("xl")]: {
                    slides: { perView: 1, spacing: 0 },
                  },
                },
              },
              plugins
            );
          });
        } catch (e) {
          // no-op
        }
      },
    };
  })(window.Drupal, window.once);
}
